import { pageEntry } from "../../client/index.ts";
import { designCopy } from "../../design/copy.ts";

const rulesQuery = (query: URLSearchParams) => ({ conta: query.get("conta") ?? undefined });

const explored = { replaceOn: ["conta"], query: rulesQuery };
export const entrypoints = [pageEntry("regras", designCopy.lugares.regras, () => import("./view.tsx"), explored)];
